import PropTypes from "prop-types";
import React from "react";
const LoadingRowSpinner = ({isLoading}) => {
if(!isLoading) return null;
return (
        <div className="col-md-12">
          <div className="w-100 element-row-message custom-icon-loading border-content-sections d-flex justify-content-center pt-5 pb-5">
            <i className="fas fa-spinner fa-spin"></i>
          </div>
        </div>
)

}

export default LoadingRowSpinner;

LoadingRowSpinner.propTypes = {
    isLoading: PropTypes.bool
}
